<template>
  <AppDialog
    title="Policy activation & editing"
    append-to-body
    show
    @close="closeDialog"
  >
    <div class="dialog-p">This policy will become active at the start of your organization's next work week.</div>

    <div class="dialog-p mt-20">
      NOTE: Editing the threshold or multiplier of a policy can only be done before members have tracked time on an
      active policy. After members have tracked time on an active policy, these fields are locked. Archiving the policy
      will also take effect on the following week.
    </div>

    <template #footer>
      <AppButton
        type="default"
        @click="closeDialog"
      >
        Continue editing
      </AppButton>

      <button
        class="btn btn-primary"
        type="submit"
        form="confirm-create-form"
        @click="onFormSubmit"
      >
        Ok
      </button>
    </template>
  </AppDialog>
</template>
<script>
export default {
  name: 'OvertimePoliciesConfirmCreateDialog',
  methods: {
    closeDialog() {
      this.$emit('close');
    },
    onFormSubmit() {
      this.$emit('close-confirmed');
    },
  },
};
</script>
